module.exports = "<p>\r\n  print works!\r\n</p>\r\n"